import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { StoreRequestStateUpdater } from '../../../shared/types/store-request-state-updater';
import { Observable, throwError } from 'rxjs';
import { ApiResponse } from '../../../shared/types/api-response';
import { catchError, map } from 'rxjs/operators';
import { MAIN_SCREEN_CONFIG } from '../types/main-screen-config';

@Injectable({
  providedIn: 'root',
})
export class MainEndpoint {
  constructor(private http: HttpClient) {}

  getServerVersion(requestStateUpdater: StoreRequestStateUpdater): Observable<string> {
    const request = MAIN_SCREEN_CONFIG.requests.getServerVersion;
    requestStateUpdater(request.name, { inProgress: true });
    return this.http.get<ApiResponse<string>>(request.url).pipe(
      map((response) => {
        requestStateUpdater(request.name, {
          inProgress: false,
          success: response.success,
        });
        return response.data;
      }),
      catchError((error: HttpErrorResponse) => {
        requestStateUpdater(request.name, {
          inProgress: false,
          error: true,
        });
        return throwError(error);
      })
    );
  }
}
